module.exports = __webpack_public_path__ + "586cb55f697164cac70cd1d54642205f.png";